export const headingSizes = {
  32: 'font-size-xl',
  24: 'font-size-lg',
  20: 'font-size-md',
};
